import { Button, Flex, Space, Typography } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faXmark } from "@fortawesome/pro-solid-svg-icons"
import { useContext } from "react"
import { LegacyJobData } from "../../../../domain/jobs/jobs"
import ReadyToInvoiceContext from "../ReadyToInvoiceContext"
import LinkCustomer from "../../InvoiceByJob/LinkCustomer"
import RedirectToJobButton from "../../InvoiceByJob/RedirectToJobButton"

const { Title } = Typography

type Props = {
  jobData: LegacyJobData
  onLinkCustomer: () => void
}

const DrawerHeader = ({ jobData, onLinkCustomer }: Props) => {
  const { clearSelection } = useContext(ReadyToInvoiceContext)

  return <Flex
    style={{
      borderBottom: '1px solid #f0f0f0',
      backgroundColor: 'white',
      height: '64px',
      padding: '0 20px',
    }}
    justify="space-between"
    align="center"
  >
    <Space>
      <Title level={5} style={{ marginBottom: 0 }}>#{jobData.no}</Title>
      <Title level={5} style={{ marginBottom: 0 }}>{jobData.name}</Title>
      <Title level={5} type="secondary" style={{ marginBottom: 0 }}>{jobData.customer.displayName}</Title>
    </Space>
    <Space>
      <RedirectToJobButton jobId={jobData.id} />
      <LinkCustomer customerQboId={jobData.customer.qboId} onClick={onLinkCustomer} />
      <Button type="text" aria-label="Close job" icon={<FontAwesomeIcon icon={faXmark} />} onClick={clearSelection} />
    </Space>
  </Flex>
}

export default DrawerHeader
